<template>
  <v-menu bottom origin="center center" transition="scale-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" v-on="on">
        <v-icon color="primary">mdi-flag</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="locale in locales"
        :key="locale"
        @click="switchLocale(locale)"
      >
        <v-list-item-title
          ><flag :iso="$t(`locales.${locale}.flag`)" />
          {{ $t(`locales.${locale}.label`) }}</v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LocalePicker',
  data () {
    return {
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    }
  },

  methods: {
    switchLocale (locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
      }
    }
  }
}
</script>
